/**
 * Works Archive Filter
 */
function initWorksFilter() {
  var panel = document.querySelector('.js-works-filter-panel');
  if (!panel) return;
  var container = panel.parentElement;
  if (!container) return;
  var axes = container.querySelectorAll('.js-works-filter-axis');
  var groups = panel.querySelectorAll('.js-works-filter-group');
  var currentOpenAxis = null;

  panel.removeAttribute('hidden');
  groups.forEach(function (g) {
    g.removeAttribute('hidden');
  });

  function setPanelOpen(open) {
    panel.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setAxisButtonExpanded(axisValue, expanded) {
    axes.forEach(function (btn) {
      var isThis = btn.getAttribute('data-axis') === axisValue;
      btn.setAttribute(
        'aria-expanded',
        isThis ? (expanded ? 'true' : 'false') : 'false'
      );
    });
  }

  function switchToAxis(axisValue) {
    axes.forEach(function (btn) {
      var isCurrent = btn.getAttribute('data-axis') === axisValue;
      btn.classList.toggle('js-works-filter-axis-current', isCurrent);
      btn.classList.toggle('p-works-filter__axis--current', isCurrent);
      btn.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    });
    groups.forEach(function (group) {
      var isCurrent = group.getAttribute('data-axis') === axisValue;
      group.classList.toggle('js-works-filter-group-current', isCurrent);
      group.classList.toggle('p-works-filter__group--current', isCurrent);
    });
  }

  function openPanel(axisValue) {
    currentOpenAxis = axisValue;
    setPanelOpen(true);
    setAxisButtonExpanded(axisValue, true);
    switchToAxis(axisValue);
  }

  function closePanel() {
    currentOpenAxis = null;
    setPanelOpen(false);
    axes.forEach(function (btn) {
      btn.classList.remove(
        'js-works-filter-axis-current',
        'p-works-filter__axis--current'
      );
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-selected', 'false');
    });
  }

  function getSelectedTagCounts() {
    var counts = {};
    groups.forEach(function (group) {
      var axis = group.getAttribute('data-axis');
      if (axis) {
        counts[axis] = group.querySelectorAll(
          '.js-works-filter-tag-checkbox:checked'
        ).length;
      }
    });
    return { counts: counts };
  }

  function updateAxisCounts(data) {
    if (!data || !data.counts) return;
    axes.forEach(function (btn) {
      var axis = btn.getAttribute('data-axis');
      var n = data.counts[axis] !== undefined ? data.counts[axis] : 0;
      var countEl = btn.querySelector('.js-works-filter-axis-count');
      if (countEl) countEl.textContent = '(' + n + ')';
    });
  }

  if (axes.length && groups.length) {
    axes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var axis = this.getAttribute('data-axis');
        if (!axis) return;
        if (currentOpenAxis === axis) {
          closePanel();
        } else {
          openPanel(axis);
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (currentOpenAxis === null) return;
    if (container.contains(e.target)) return;
    closePanel();
  });

  function syncCheckboxState(cb) {
    var label = cb.closest('.js-works-filter-tag-btn');
    if (label) {
      var on = !!cb.checked;
      label.classList.toggle('js-works-filter-tag-btn-selected', on);
      label.classList.toggle('p-works-filter__tag-btn--selected', on);
      label.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    updateAxisCounts(getSelectedTagCounts());
  }

  panel
    .querySelectorAll('.js-works-filter-tag-checkbox')
    .forEach(function (cb) {
      cb.addEventListener('change', function () {
        syncCheckboxState(this);
      });
    });

  // role="button" on label suppresses native label-toggle; handle click to toggle checkbox
  panel.querySelectorAll('.js-works-filter-tag-btn').forEach(function (label) {
    label.addEventListener('click', function (e) {
      var cb = this.querySelector('.js-works-filter-tag-checkbox');
      if (!cb || e.target === cb) return;
      e.preventDefault();
      cb.checked = !cb.checked;
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  var resetBtn = panel.querySelector('.js-works-filter-reset');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      panel
        .querySelectorAll('.js-works-filter-tag-checkbox')
        .forEach(function (cb) {
          cb.checked = false;
        });
      panel
        .querySelectorAll('.js-works-filter-tag-btn')
        .forEach(function (lbl) {
          lbl.classList.remove(
            'js-works-filter-tag-btn-selected',
            'p-works-filter__tag-btn--selected'
          );
          lbl.setAttribute('aria-pressed', 'false');
        });
      updateAxisCounts(getSelectedTagCounts());
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWorksFilter);
} else {
  initWorksFilter();
}

// =============================================================
// Works SP Filter Modal
// =============================================================
var WORKS_SP_FOCUSABLE_SELECTOR =
  'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

function WorksFilterSpModal(trigger, modal) {
  this.trigger = trigger;
  this.modal = modal;
  this.sheet = modal.querySelector('.js-works-filter-sp-sheet');
  this.overlay = modal.querySelector('.js-works-filter-sp-overlay');
  this.btnClose = modal.querySelector('.js-works-filter-sp-close');
  this.btnApply = modal.querySelector('.js-works-filter-sp-apply');
  this.baseUrl = modal.dataset.baseUrl || '';
  this.axisBtns = Array.from(
    modal.querySelectorAll('.js-works-filter-sp-axis-btn')
  );
  this._abortController =
    typeof AbortController !== 'undefined' ? new AbortController() : null;
}

WorksFilterSpModal.prototype.getFocusables = function (container) {
  return Array.from(
    container.querySelectorAll(WORKS_SP_FOCUSABLE_SELECTOR)
  ).filter(function (el) {
    if (el.hasAttribute('hidden')) return false;
    var ancestor = el.closest('[hidden]');
    if (ancestor && ancestor !== container) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  });
};

WorksFilterSpModal.prototype.openModal = function () {
  this.modal.hidden = false;
  document.body.style.overflow = 'hidden';
  this.trigger.setAttribute('aria-expanded', 'true');
  var self = this;
  // display 変更が描画されてからクラスを付与してトランジションを起動する
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      self.modal.classList.add('is-open');
      // tabindex="-1" のシート要素にフォーカスを移す。
      // インタラクティブ要素への直接フォーカスを避けることで、
      // Safari が :focus-visible を誤発火するのを防ぐ。
      if (self.sheet) {
        self.sheet.focus({ preventScroll: true });
      } else {
        var focusables = self.getFocusables(self.modal);
        if (focusables.length) focusables[0].focus();
      }
    });
  });
};

WorksFilterSpModal.prototype.closeModal = function () {
  var self = this;
  this.modal.classList.remove('is-open');
  this.trigger.setAttribute('aria-expanded', 'false');
  this.trigger.focus();

  var reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  if (reducedMotion || !this.sheet) {
    this.modal.hidden = true;
    document.body.style.overflow = '';
    return;
  }

  var sheet = this.sheet;
  var modal = this.modal;
  function onTransitionEnd(e) {
    if (e.propertyName !== 'transform') return;
    modal.hidden = true;
    document.body.style.overflow = '';
    sheet.removeEventListener('transitionend', onTransitionEnd);
  }
  sheet.addEventListener('transitionend', onTransitionEnd);
};

WorksFilterSpModal.prototype.toggleAxis = function (btn) {
  var axisEl = btn.closest('.js-works-filter-sp-axis');
  var tagsContainer = axisEl
    ? axisEl.querySelector('.p-works-filter-sp__tags')
    : null;
  if (!tagsContainer) return;
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  var self = this;
  this.axisBtns.forEach(function (b) {
    if (b === btn) return;
    b.setAttribute('aria-expanded', 'false');
    var axisOther = b.closest('.js-works-filter-sp-axis');
    var tc = axisOther
      ? axisOther.querySelector('.p-works-filter-sp__tags')
      : null;
    if (tc) self._collapseAxisTags(tc);
  });
  btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  if (expanded) {
    this._collapseAxisTags(tagsContainer);
  } else {
    this._expandAxisTags(tagsContainer);
  }
};

WorksFilterSpModal.prototype._expandAxisTags = function (tags) {
  tags.hidden = false;
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      tags.classList.add('is-open');
    });
  });
};

WorksFilterSpModal.prototype._collapseAxisTags = function (tags) {
  if (tags.hidden) return;
  tags.classList.remove('is-open');
  var reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  if (reducedMotion) {
    tags.hidden = true;
    return;
  }
  tags.addEventListener('transitionend', function onEnd(e) {
    if (e.propertyName !== 'grid-template-rows') return;
    tags.hidden = true;
    tags.removeEventListener('transitionend', onEnd);
  });
};

WorksFilterSpModal.prototype.toggleTag = function (tag) {
  var pressed = tag.getAttribute('aria-pressed') === 'true';
  var next = !pressed;
  tag.setAttribute('aria-pressed', next ? 'true' : 'false');
  tag.classList.toggle('p-works-filter-sp__tag--selected', next);
  this.updateAxisCounts();
};

WorksFilterSpModal.prototype.updateAxisCounts = function () {
  var axes = this.modal.querySelectorAll('.js-works-filter-sp-axis');
  axes.forEach(function (axis) {
    var count = axis.querySelectorAll(
      '.js-works-filter-sp-tag[aria-pressed="true"]'
    ).length;
    var countEl = axis.querySelector('.js-works-filter-sp-axis-count');
    if (countEl) countEl.textContent = '(' + count + ')';
  });
  this.updateTriggerCount();
};

WorksFilterSpModal.prototype.updateTriggerCount = function () {
  var total = this.modal.querySelectorAll(
    '.js-works-filter-sp-tag[aria-pressed="true"]'
  ).length;
  var label = this.trigger.querySelector('.c-filter__btn--label');
  if (label) {
    label.textContent = total > 0 ? 'Filter (' + total + ')' : 'Filter';
  }
};

WorksFilterSpModal.prototype.applyFilter = function () {
  var params = new URLSearchParams();
  this.modal
    .querySelectorAll('.js-works-filter-sp-tag[aria-pressed="true"]')
    .forEach(function (tag) {
      var queryVar = tag.dataset.queryVar;
      var value = tag.dataset.value;
      if (queryVar && value) {
        params.append(queryVar + '[]', value);
      }
    });
  var query = params.toString();
  window.location.href = this.baseUrl + (query ? '?' + query : '');
};

WorksFilterSpModal.prototype.handleKeydown = function (e) {
  if (this.modal.hidden) return;
  if (e.key === 'Escape') {
    e.preventDefault();
    this.closeModal();
    return;
  }
  if (e.key !== 'Tab') return;
  var focusables = this.getFocusables(this.modal);
  if (focusables.length === 0) return;
  var idx = focusables.indexOf(document.activeElement);
  if (idx === -1) return;
  var nextIdx = e.shiftKey
    ? (idx - 1 + focusables.length) % focusables.length
    : (idx + 1) % focusables.length;
  e.preventDefault();
  focusables[nextIdx].focus();
};

WorksFilterSpModal.prototype.bindEvents = function () {
  var self = this;
  this.trigger.addEventListener('click', function () {
    if (self.modal.hidden) {
      self.openModal();
    } else {
      self.closeModal();
    }
  });
  if (this.overlay) {
    this.overlay.addEventListener('click', function () {
      self.closeModal();
    });
  }
  if (this.btnClose) {
    this.btnClose.addEventListener('click', function () {
      self.closeModal();
    });
  }
  if (this.btnApply) {
    this.btnApply.addEventListener('click', function () {
      self.applyFilter();
    });
  }
  this.axisBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      self.toggleAxis(btn);
    });
  });
  this.modal
    .querySelectorAll('.js-works-filter-sp-tag')
    .forEach(function (tag) {
      tag.addEventListener('click', function () {
        self.toggleTag(tag);
      });
    });
  var keydownOptions = self._abortController
    ? { signal: self._abortController.signal }
    : {};
  document.addEventListener(
    'keydown',
    function (e) {
      self.handleKeydown(e);
    },
    keydownOptions
  );
};

WorksFilterSpModal.prototype.destroy = function () {
  if (this._abortController) {
    this._abortController.abort();
  }
};

WorksFilterSpModal.prototype.init = function () {
  this.updateAxisCounts();
  this.bindEvents();
};

function initWorksFilterSp() {
  var trigger = document.querySelector('.js-works-filter-sp-trigger');
  var modal = document.getElementById('works-filter-sp-modal');
  if (!trigger || !modal) return;
  var instance = new WorksFilterSpModal(trigger, modal);
  instance.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWorksFilterSp);
} else {
  initWorksFilterSp();
}
